// TariffGroup/TariffGroupsPage.tsx
import React, {useEffect, useState} from 'react';
import TariffGroupCard from './TariffGroupCard';
import pprint from '../../Utils/pprint';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import {FRCT} from 'WideLayout/Layouts';
import CircularProgress from 'Core/components/elements/CircularProgress';
import Head from 'Core/components/Head';
import {ITariffGroup} from "Types/psychology/tariff";

interface TariffGroupsPageProps {
    cls?: string;
}

const TariffGroupsPage: React.FC<TariffGroupsPageProps> = ({cls}) => {
    const [groups, setGroups] = useState<ITariffGroup[]>([]);
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await axios.get('/api/v1/tariff-groups/');
                pprint('Tariff Groups');
                pprint(response.data);
                setGroups(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        fetchGroups();
    }, []);

    if (!groups.length) return <CircularProgress size={'150px'}/>;

    return (
        <>
            <Head
                title={'Группы тарифов | Лайф Хелп'}
                description={'Группы тарифов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/tariff-groups`}
            />
            <FRCT cls={cls} pos={'relative'} p={2} wrap g={2} scroll={'y-auto'}>
                {groups.map((group) => (
                    <TariffGroupCard key={group.id} group={group}/>
                ))}
            </FRCT>
        </>
    );
};

export default TariffGroupsPage;
